/**
 * 座位状态
 */
export const seatStatus = [
  {
    title: "可售",
    status: 0,
    // bgColor: "#EEFFBB",
    bgColor: "#b2cf58",
  },
  {
    title: "已售",
    status: 1,
    // bgColor: "#66DD00",
    bgColor: "#5cc500",
  },
  {
    title: "已订",
    status: 2,
    // bgColor: "#B94FFF",
    bgColor: "#B94FFF",
  },
  {
    title: "补票",
    status: 3,
    // bgColor: "#EEFFBB",
    bgColor: "#b2cf58",
  },
  {
    title: "停售",
    status: 4,
    // bgColor: "#b3d4fc",
    bgColor: "#a0bfe5",
  },
  {
    title: "已发",
    status: 7,
    // bgColor: "#FF8040",
    bgColor: "#FF8040",
  },
  {
    title: "已锁",
    status: 8,
    // bgColor: "#444444",
    bgColor: "#8b8b8b",
  },
  {
    title: "留位",
    status: 9,
    // bgColor: "#99FFCC",
    bgColor: "#86dfb2",
  },
  {
    title: "检票",
    status: "A",
    // bgColor: "#FFCC00",
    bgColor: "#e4b600",
  },
  {
    title: "混检",
    status: "B",
    // bgColor: "#0080FF",
    bgColor: "#0080FF",
  },
  {
    title: "手工检票",
    status: "C",
    // bgColor: "#00E3E3",
    bgColor: "#01c7c7",
  },
  {
    title: "保底划位",
    status: "D",
    // bgColor: "#9F5000",
    bgColor: "#9F5000",
  },
  {
    title: "限制划位",
    status: "E",
    // bgColor: "#8B8B00",
    bgColor: "#8B8B00",
  },
];

/**
 * 检票座位状态
 */
export const ticketCheckPhoneStatus = [
  {
    id: 0,
    count: 0,
    status: (current) => current == 0,
    color: "blue",
  },
  {
    id: 1,
    count: 1,
    status: (current) => current == 1,
    color: "orange",
  },
  {
    id: 2,
    count: 2,
    status: (current) => current == 2,
    color: "pink",
  },
  {
    id: 3,
    count: 3,
    status: (current) => current >= 3,
    color: "purple",
  },
];
